<div class="flex justify-between items-center pb-2 border-b border-gray-300">
  <span class="text-lg font-bold text-gray-900">{{
    'CONSTANT.RECOMMENDATION_SUBTYPE.' + intervention().subType | translate
  }}</span>
  <div class="flex items-baseline gap-1 text-gray-600">
    <i class="pi pi-calendar"></i>
    <span
      class="text-m font-normal"
      [aoDateWeekNumber]="intervention().pesticides?.completedDate"
    ></span>
  </div>
</div>
<div class="mt-2 pb-2 border-b border-gray-300">
  <div class="flex justify-between">
    <span>{{ 'INTERVENTION.PESTICIDES.WATER_AMOUNT' | translate }}</span>
    <span class="font-semibold"
      >{{ intervention().pesticides?.waterAmount }} {{ intervention().pesticides?.waterUnit }} /
      {{ intervention().pesticides?.waterAreaUnit | translateConstant: constantService.areaUnit }}</span
    >
  </div>
</div>
@for (product of intervention().pesticides?.products; track product) {
  <div class="mt-1.5 pb-1.5">
    <div class="flex justify-between">
      <span class="font-medium">{{ product.name }}</span>
      <span class="font-semibold"
        >{{ product.rate }} {{ product.rateUnit }} /
        {{ product.rateAreaUnit | translateConstant: constantService.areaUnit }}</span
      >
    </div>
    <div>
      @for (ingredient of product.activeIngredientsNames; track ingredient; let last = $last) {
        <span class="text-xs text-gray-500"
          >{{ ingredient }}
          @if (!last) {
            <span>, </span>
          }
        </span>
      }
    </div>
  </div>
}
@if (intervention().note?.length) {
  <div class="mt-1.5 text-sm">
    {{ intervention().note }}
  </div>
}
